// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"6f0af6bb","453":"f5117e8e","862":"cc9960e3"}[chunkId] + ".chunk.js";
};